import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Bugsnag } from "@air/utils-error";
import LogRocket from "logrocket";
import setupLogRocketReact from "logrocket-react";
import { useEffect, useRef } from "react";
export const LogRocketContainer = (param)=>{
    let { children } = param;
    const loadedRef = useRef(false);
    useEffect(()=>{
        if (window.location.hostname === "app.air.inc" && !loadedRef.current) {
            const logRocketKey = process.env.NEXT_PUBLIC_LOGROCKET;
            if (!logRocketKey) {
                return console.error("No LogRocket key was provided! Missing the NEXT_PUBLIC_LOGROCKET environment variable.");
            }
            LogRocket.init(logRocketKey, {
                dom: {
                    /** @see https://app.logrocket.com/0mjm6m/air/settings/privacy/ */ inputSanitizer: true
                },
                network: {
                    requestSanitizer: (request)=>{
                        var _request_url, // body can be a string or an object (for upload requests)
                        _request_body, _request_body1, _request_body2;
                        // Don't share payment info
                        if ((_request_url = request.url) === null || _request_url === void 0 ? void 0 : _request_url.includes("stripe")) {
                            return null;
                        }
                        // Don't share Authorization header
                        request.headers.Authorization = undefined;
                        // Hide body from auth-related requests
                        if (typeof request.body !== "string" || ((_request_body = request.body) === null || _request_body === void 0 ? void 0 : _request_body.includes("password")) || ((_request_body1 = request.body) === null || _request_body1 === void 0 ? void 0 : _request_body1.includes("Password")) || ((_request_body2 = request.body) === null || _request_body2 === void 0 ? void 0 : _request_body2.includes("AuthParameters"))) {
                            request.body = undefined;
                        }
                        return request;
                    }
                }
            });
            setupLogRocketReact(LogRocket);
            LogRocket.getSessionURL((sessionURL)=>{
                if (!!window.Intercom) {
                    console.info("LogRocket - integrating intercom");
                    window.Intercom("trackEvent", "LogRocket", {
                        sessionURL
                    });
                }
                if (!!window.ga) {
                    window.ga("send", {
                        hitType: "event",
                        eventCategory: "LogRocket",
                        eventAction: sessionURL
                    });
                }
            });
            loadedRef.current = true;
            window.hasLogRocketInitialized = true;
            if (Bugsnag.isStarted()) {
                Bugsnag.addOnError((event)=>{
                    event.addMetadata("LogRocket", {
                        sessionURL: LogRocket.sessionURL
                    });
                });
            }
        }
    }, []);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
};
